export const SINGLE_FAMILY = 'single_family';
export const TOWNHOME = 'townhome';
export const APARTMENT_OR_CONDO = 'apartment_or_condo';
export const OTHER = 'other';
